import {FontSizes, vs} from '@/Utils/Dimensions';
import CCColors from '@/Utils/CCColors';
import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  section: {
    marginVertical: vs(16),
    paddingHorizontal: vs(12),
  },
  sectionHeader: {
    fontSize: FontSizes[16],
    fontWeight: 'bold',
    color: '#4D3F37',
    marginBottom: vs(8),
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  input: {
    flex: 1,
    marginHorizontal: vs(8),
    marginVertical: vs(8),
    minWidth: vs(140),
  },
  errorText: {
    color: 'red',
    textAlign: 'center',
    marginVertical: vs(8),
  },
  successText: {
    color: 'green',
    textAlign: 'center',
    marginVertical: vs(8),
  },
  buttonContainer: {
    alignItems: 'center',
    marginVertical: vs(16),
  },
  tabContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
